import React, {Component} from 'react';
import classnames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';

class Tabs extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        this.props.input.onChange(value);
    }

    render() {
        let {
            input,
            options,
            className,
        } = this.props;

        return (
            <Nav tabs role="tablist">
                {options.map((option, key) => {
                    return <NavItem key={key}>
                        <NavLink
                            role="tab"
                            className={classnames({ active: input.value === option.value })}
                            onClick={() => { this.onChange(option.value); }}
                        >
                            {option.label}
                        </NavLink>
                    </NavItem>
                })}
            </Nav>
        );
    }
}

export default Tabs;


// WEBPACK FOOTER //
// ./web/src/components/common/form/Tabs.jsx